import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestOptionsPostTypePatch = {
    path: "/options/:post_type",
    method: RouteHttpVerb.PATCH
};
export { locationRestOptionsPostTypePatch };
